import * as React from 'react'
const DeleteIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M14.07 2.87h-3.9a2.17 2.17 0 00-4.34 0h-3.9a.43.43 0 00-.43.43v.07a.42.42 0 00.42.35h.48l1.13 9.53a1.72 1.72 0 001.72 1.5h5.48a1.72 1.72 0 001.72-1.5l1.13-9.53h.48a.43.43 0 100-.85zM8 1.6a1.28 1.28 0 011.3 1.27H6.7A1.28 1.28 0 018 1.6zm3.6 11.55a.86.86 0 01-.86.75H5.26a.86.86 0 01-.86-.75L3.29 3.72h9.42z" className="-secondary-color" fill="#d7dae0"/>
      <path d="M6.7 5.84a.4.4 0 00-.43.37v5.27a.43.43 0 00.43.3.4.4 0 00.43-.37V6.15a.43.43 0 00-.43-.31zM9.73 6.15a.43.43 0 00-.43-.31.4.4 0 00-.43.37v5.27a.43.43 0 00.43.3.4.4 0 00.43-.37V6.15z" className="-primary-color" fill="#a5aab8"/>
    </svg>
    
  )
}

export default DeleteIcon